import React from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { bindActionCreators } from "redux";
import { logout, setActiveDialog } from "ducks/app";
import { saveUserRequest } from "ducks/data";
import { Menu, Dropdown, Avatar, Badge } from "antd";
import EditUserModal from "../../../Profile/modal";
import * as Consts from "../../../../config";

const _ = require("lodash");

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      logout,
      push,
      setActiveDialog,
      saveUserRequest
    },
    dispatch
  );

const mapStateToProps = (state, props) => ({
  userState: state.app.userState,
  activeDialog: state.app.activeDialog
});

@connect(
  mapStateToProps,
  mapDispatchToProps
)
class ProfileMenu extends React.Component {
  state = {
    count: 7
  };

  addCount = () => {
    this.setState({
      count: this.state.count + 1
    });
  };

  render() {
    const { userState, logout } = this.props;

    let user = { ...userState };
    let hasAccess =
      _.intersection(
        [Consts.UserPermission.AccountAdmin],
        this.props.userState.roles
      ).length > 0;

    let mainRole = _.first(userState.roles);
    let displayRole = "Clinician";
    switch (mainRole) {
      case Consts.UserPermission.SuperAdmin:
        displayRole = "Super Administrator";
        break;
      case Consts.UserPermission.AccountAdmin:
        displayRole = "Administrator";
        break;
      default:
        displayRole = "Clinician";
        break;
    }
    const menu = (
      <Menu selectable={false}>
        <Menu.Item>
          <div className="py-3 px-4">
            <strong>
              {`Hello, ${
                userState.attributes.preferredName
                  ? userState.attributes.preferredName
                  : userState.attributes.firstName
              } ${userState.attributes.lastName}`}
            </strong>
            <div>{userState.attributes.email}</div>
            <i className="muted">{displayRole}</i>
          </div>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item
          onClick={() =>
            this.props.setActiveDialog(`patient-edit-${userState.id}`)
          }
        >
          <a href="#" onClick={(e) => e.preventDefault()}>
            <i className="icon icon-user" /> Edit Profile
          </a>
        </Menu.Item>
        {hasAccess ? <Menu.Divider /> : undefined}
        {hasAccess ? (
          <Menu.Item onClick={() => this.props.push("/accounts")}>
            <a href="#" onClick={(e) => e.preventDefault()}>
              <i className="icon icon-settings" /> Manage Account
            </a>
          </Menu.Item>
        ) : (
          undefined
        )}
        <Menu.Divider />
        <Menu.Item>
          
          <a type="button" onClick={logout}>
            <i className="icon icon-logout" /> Logout
          </a>
        </Menu.Item>
      </Menu>
    );
    return (
      <div className="topbar__dropdown d-inline-block">
        <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
          <a className="ant-dropdown-link" href="/">
            <i className="icon icon-user" />
            <span className="ml-2">
              Hi{" "}
              {userState.attributes.preferredName
                ? userState.attributes.preferredName
                : userState.attributes.firstName}
            </span>
          </a>
        </Dropdown>

        <EditUserModal
          key={user.id}
          show={this.props.activeDialog === `patient-edit-${user.id}`}
          onCancel={this.props.setActiveDialog}
          onSave={this.props.saveUserRequest}
          user={user}
          userRole={undefined}
          showRole={false}
        />
      </div>
    );
  }
}

export default ProfileMenu;



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/TopBar/ProfileMenu/index.js